import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { Chip } from 'src/components/shared/Chip'
import { GSIcon } from 'src/components/shared/GSIcon'
import { TitledTooltip } from 'src/components/shared/TitledTooltip'
import { colors } from 'src/theme'

interface Props {
  isEnabled: boolean
}

const reActivationTooltip = {
  enabled: {
    title: 'Automatic Re-Activation Enabled',
    description:
      'Contractors are automatically reactivated once they become compliant again, regardless of how they were deactivated.',
  },
  disabled: {
    title: 'Automatic Re-Activation Disabled',
    description:
      'Contractors remain in their current deactivated state even after becoming compliant.',
  },
}

const ContractorReActivationChipComponent = ({ isEnabled }: Props) => {
  const color = isEnabled ? colors.SHADES_GREY_600 : colors.COLORS_RED_500
  const backgroundColor = isEnabled ? colors.SHADES_GREY_100 : colors.COLORS_RED_200
  const { title, description } = isEnabled
    ? reActivationTooltip.enabled
    : reActivationTooltip.disabled

  return (
    <TitledTooltip
      title={title}
      content={
        <Typography variant="body2" color={colors.SHADES_GREY_300}>
          {description}
        </Typography>
      }
    >
      <Chip
        text={isEnabled ? 'Enabled' : 'Disabled'}
        textColor={color}
        className={{ backgroundColor, color }}
        icon={<GSIcon iconName={isEnabled ? 'gs_checkmark' : 'gs_close'} width={14} height={14} />}
      />
    </TitledTooltip>
  )
}

export const ContractorReActivationChip = memo(ContractorReActivationChipComponent)
